import TargetLink from "@/components/TargetLink";
import styles from "@/styles/Informations.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InformationRow(_ref) {
  let {
    item
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.row,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.section,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.inner,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.date,
          children: item.date
        }), /*#__PURE__*/_jsx(TargetLink, {
          className: styles.link,
          href: item.url,
          blank: item.targetBlank,
          children: item.title
        })]
      })
    })
  });
}